import { render } from "./TypographyContent.vue?vue&type=template&id=00762382"
import script from "./TypographyContent.vue?vue&type=script&lang=js"
export * from "./TypographyContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__